import { useEffect } from 'react';
import { notifyPageReady } from 'src/telemetry/routePerformance';

export interface PageReadyState {
  ready: boolean;
  outcome?: 'success' | 'error';
}

/**
 * Declares the moment a page's primary content and controls are usable, for
 * routes whose metadata sets `performance.readiness: 'manual'`. Emits once per
 * navigation, never throws, and is a no-op on routes without manual readiness
 * — so shared components can call it unconditionally.
 */
export function usePageReady({
  ready,
  outcome = 'success',
}: PageReadyState): void {
  useEffect(() => {
    if (ready) notifyPageReady(outcome);
  }, [ready, outcome]);
}
